import Image from '@anm/components/image/Image';
import { flexCenter, stretchBlock } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { SocialAvatarVariant } from './index';

export const UserImage = styled(Image)`
  object-fit: cover;
  border-radius: 50%;
`;

export const SocialImage = styled(Image)`
  top: 0;
  height: 100%;
  position: absolute;
`;

export const DestinationWrapper = styled.div`
  z-index: 2;
  position: absolute;
  border-radius: 50%;
  border: 2px solid #fff;
`;

export type WrapperProps = {
  variant: SocialAvatarVariant;
  isSelected?: boolean;
  isSelectList?: boolean;
};

const variants: { [key in SocialAvatarVariant]: ReturnType<typeof css> } = {
  '50x50': css`
    ${UserImage} {
      width: 50px;
      height: 50px;
    }
    ${DestinationWrapper} {
      right: -4px;
      bottom: -2px;
      width: 22px;
      height: 22px;
    }
  `,
  '30x30': css`
    ${UserImage} {
      width: 30px;
      height: 30px;
    }
    ${DestinationWrapper} {
      right: -6px;
      bottom: -2px;
      width: 16px;
      height: 16px;
    }
  `
};

const selectedStyles = css`
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid var(--blue_100);
`;

const notSelectedStyles = css`
  opacity: 0.6;
  cursor: pointer;
  border: 3px solid transparent;
`;

export const UserImageContainer = styled.div<WrapperProps>`
  position: relative;
  align-items: center;
  ${flexCenter};
  ${({ variant }) => variants[variant]}
  ${({ isSelected }) => isSelected && selectedStyles};
  ${({ isSelectList, isSelected }) => isSelectList && !isSelected && notSelectedStyles}

  &:after {
    content: '';
    z-index: 1;
    ${stretchBlock};
    border-radius: 50%;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border: 1px solid rgba(0, 56, 87, 0.2);
  }
`;
